import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolTypography } from '@synergy/components';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { CustomerDetailTabs } from '../models/enum/customer-detail-tabs';

export const CustomerTopicsEmpty = () => {
    const navigate = useNavigate();

    return (
        <Stack gap={2} sx={{ my: 2 }} alignItems="start">
            <PoolTypography id="app.contactsAndOrganizations.customer.noTopics" />
            <PoolButton
                styleType="firstLevel"
                color="primary"
                onClick={() => navigate('../' + CustomerDetailTabs.Employee)}
            >
                <FormattedMessage id="app.contactsAndOrganizations.customer.gotToMemberTab" />
            </PoolButton>
        </Stack>
    );
};
